<template>
  <div class="entry-list">
    <van-tabs v-model="role" @change="onClick">
      <van-tab title="队伍报名表" :name="1"></van-tab>
      <van-tab title="个人参赛表" :name="0"></van-tab>
    </van-tabs>

     <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
       <div class="teams" v-if="teams.length > 0">
          <div v-if="role === 1">
            <div class="item" v-for="item in teams" :key="item.id" @click="goEntryInfo(item)">
              <div class="info">
                <img :src="imageView(item.badge)" v-if="item.badge"/>
                <div class="left">
                  <div class="team-name">
                    {{ item.name }}
                  <div class="right">
                  <div class="">
                    <div class="status _0" v-if="item.isSubmit === 0">未提交</div>
                    <div class="status _0" v-else-if="item.auditStatus === 0 || item.auditStatus === 1">待确认</div>
                    <div class="status _1" v-else-if="item.auditStatus === 3">已锁定</div>
                    <div class="status _1" v-else-if="item.auditStatus === 2">已确认</div>
                    <div class="status _2" v-else-if="item.auditStatus === -1">已退回</div>
                  </div>
                </div>
                  </div>
                    <div class="match-name">
                      <div class="info">
                        <img v-if="match.icon" :src="imageView(match.icon)" /><span class="overflow-text">{{ item.chineseName.split('_')[0] }}</span>
                      </div>
                  </div>
                  <div class="group-name">{{ item.chineseName.split('_')[1] }}</div>
                </div>
              </div>
              <div class="bottom" v-if="item.auditStatus === -1 && item.auditRemark">
                退回理由：{{ item.auditRemark }}
              </div>
            </div>
          </div>
          <div v-else>
            <div class="item player" v-for="item in teams" :key="item.id" @click="goPlayerInfo(item)">
              <img :src="imageView(item.avatar)" v-if="item.avatar"/>
              <div class="info2">
                <div class="name">{{ item.trueName }}</div>
                <div class="team-name">{{ item.name }}</div>
                <div class="match-name">{{ item.chineseName }}</div>
              </div>
              <div class="status-info">
                <div>
                  <div class="status _0" v-if="item.isSubmit === 0">未提交</div>
                  <div class="status _0" v-else-if="item.auditStatus === 0 || item.auditStatus === 1">待确认</div>
                  <div class="status _1" v-else-if="item.auditStatus === 3">已锁定</div>
                  <div class="status _1" v-else-if="item.auditStatus === 2">已确认</div>
                  <div class="status _2" v-else-if="item.auditStatus === -1">已退回</div>
                </div>
                <div class="pay-info">
                  <div class="pay" @click.stop="doPay(item)" v-if="item.isOpenCharge === 1 && item.feeMethod === 1 && item.orderStatus !== 1 && item.orderStatus !== 2">付 款</div>
                </div>
              </div>
            </div>
          </div>
       </div>
       <van-empty v-else :description="emptyDescription" />
     </van-pull-refresh>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabs, Tab, Dialog, Empty, PullRefresh, Toast } from 'vant'
Vue.use(Tabs).use(Tab).use(Dialog).use(Empty).use(PullRefresh).use(Toast)
import { getBMUnionMatch,getMatchTeamListByUser,getBMMatchOrderListByUser,bangsaishiCreatePlayerSignupOrder,bangsaishiCreateTeamSignupOrder } from '@/api/match'
import { QNImageUtil } from '@/utils'
import { getPassport } from "@/libs/passport";

export default {
  data() {
    return {
      unionMatchId: '',
      accountId: '',
      match: {},
      teams: [],
      isLoading: false,
      orderIndex: 0,
      role: 1
    };
  },
  computed: {
    /** 与 doPay 一致：根据报名截止 / 资料修改截止时间判断是否已截止 */
    isRegistrationClosed() {
      const regEndDate = this.match.regEndDate || ''
      const regUpdateEndDate = this.match.regUpdateEndDate || ''
      const now = Date.now()
      if (regEndDate && regUpdateEndDate) {
        return (
          now > new Date(regEndDate).getTime() &&
          now > new Date(regUpdateEndDate).getTime()
        )
      }
      if (regEndDate) {
        return now > new Date(regEndDate).getTime()
      }
      if (regUpdateEndDate) {
        return now > new Date(regUpdateEndDate).getTime()
      }
      return false
    },
    emptyDescription() {
      if (this.isRegistrationClosed) {
        return '报名已截止，您未报名参赛'
      }
      return '您未报名'
    },
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        const role = this.$route.query.role || 1
        this.role = Number(role)
        this.unionMatchId = this.$route.query.unionMatchId || ''
        this.accountId = this.$route.query.accountId || ''
        if (this.unionMatchId) {
          this.getBMUnionMatch()
          this.getMatchTeamListByUser()
          this.getBMMatchOrderListByUser()
        } else if (this.accountId) {
          this.getMatchTeamListByUser()
          this.getBMMatchOrderListByUser()
        }
      }
    })
  },
  methods: {
    getBMUnionMatch() {
      if (!this.unionMatchId) return
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          document.title = data.match.chineseName
          const shareObj = {
            title: this.match.chineseName,
            abstract: '我的报名',
            image: QNImageUtil.imageView(this.match.icon)
          }
          this.wxShare(shareObj)
        }
      })
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getMatchTeamListByUser() {
      const params = {
        role: this.role,
        orderIndex: this.orderIndex
      }
      if (this.unionMatchId) {
        params.unionMatchId = this.unionMatchId
      } else if (this.accountId) {
        params.accountId = this.accountId
      } else {
        params.unionMatchId = this.unionMatchId
      }
      getMatchTeamListByUser(params).then(res => {
        if (res) {
          const data = res.data
          this.teams = data.list
          this.isLoading = false
          const user = data.user || {}
          if (!user.mobile) {
            Dialog.alert({
              title: '您还没有关联手机号',
              message: '关联手机号后，可查看电子参赛证，获取看更多赛事信息',
            }).then(() => {
              this.$router.push('/entry-page/correlate-mobile')
            })
          }
        }
      })
    },
    getBMMatchOrderListByUser() {
      const params = {}
      if (this.unionMatchId) {
        params.unionMatchId = this.unionMatchId
      } else if (this.accountId) {
        params.accountId = this.accountId
      } else {
        params.unionMatchId = this.unionMatchId
      }
      getBMMatchOrderListByUser(params).then(res => {
        if (res) {
          const data = res.data
          const list = data.list || []
          const l = list.find(item => item.orderStatus === 0)
          console.log(l);
          
          if (l) {
            Dialog.confirm({
              title: '尚未支付',
              message: '有订单尚未支付',
              cancelButtonText: '我再想想',
              confirmButtonText: '前往支付'
            }).then(() => {
              const category = l.feeMethod === 1 ? 1 : 0
              const q = this.scopedQuery(l, `orderId=${l.orderId}&category=${category}&matchId=${l.matchId}&teamId=${l.teamId}`)
              this.$router.push(`/entry-page/payment?${q}`)
            })
          }
        }
      })
    },
    onClick() {
      this.getMatchTeamListByUser()
    },
    onRefresh() {
      this.getMatchTeamListByUser()
    },
    /**
     * 列表项 / 订单行上的 unionMatchId 由接口返回；机构入口进页时路由可能没有 unionMatchId，跳转子页仍需带上每条数据的 unionMatchId。
     * 机构维度保留 accountId，便于返回「机构下全部报名」列表。
     */
    listScopeQuery(row) {
      const qs = []
      const unionId = (row && row.unionMatchId) || this.unionMatchId
      if (unionId) {
        qs.push(`unionMatchId=${unionId}`)
      }
      if (this.accountId) {
        qs.push(`accountId=${this.accountId}`)
      }
      return qs.join('&')
    },
    /** listScopeQuery 可能为空，与后续参数拼接时避免 ?& 或 && */
    scopedQuery(row, restQuery) {
      const scope = this.listScopeQuery(row)
      return scope ? `${scope}&${restQuery}` : restQuery
    },
    goEntryInfo(item) {
      const q = this.scopedQuery(item, `matchId=${item.matchId}&teamId=${item.teamId}`)
      if (item.unitType === 1) {
        this.$router.push(`/entry-page/person-info?${q}`)
      } else {
        this.$router.push(`/entry-page/entry-info?${q}`)
      }
    },
    goPlayerInfo(item) {
      const q = this.scopedQuery(item, `matchId=${item.matchId}&teamId=${item.teamId}&playerId=${item.playerId}`)
      this.$router.push(`/entry-page/entry-info-player?${q}`)
    },
     getPartByIndex(s, i) {
      if (!s) return ''
      const arr = s.split('_')
      if (arr.length > i) return arr[i]
      return ''
    },
    doPay(item) {
      const regEndDate = this.match.regEndDate || ''
      const regUpdateEndDate = this.match.regUpdateEndDate || ''
      if (regEndDate && regUpdateEndDate) {
        if (new Date().getTime() > new Date(regEndDate).getTime() && new Date().getTime() > new Date(regUpdateEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      } else if (regEndDate) {
        if (new Date().getTime() > new Date(regEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      } else if (regUpdateEndDate) {
        if (new Date().getTime() > new Date(regUpdateEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      }
      const params = {
        matchId: item.matchId,
        teamId: item.teamId
      }
      if (item.role === 0) {
        params.playerId = item.playerId
        bangsaishiCreatePlayerSignupOrder(params).then(res => {
          if (res) {
            const q = this.scopedQuery(item, `orderId=${res.data.orderId}&category=1&matchId=${item.matchId}&teamId=${item.teamId}&playerId=${item.playerId}`)
            this.$router.push(`/entry-page/payment?${q}`)
          }
        })
      } else if (item.role === 1) {
        bangsaishiCreateTeamSignupOrder(params).then(res => {
          if (res) {
            const q = this.scopedQuery(item, `orderId=${res.data.orderId}&category=0&matchId=${item.matchId}&teamId=${item.teamId}`)
            this.$router.push(`/entry-page/payment?${q}`)
          }
        })
      }

    },
  },
};
</script>

<style scoped lang="scss">
.entry-list{
   background-color: #F8F8F8;
    border-radius: 4px 4px 8px 8px;
    margin-bottom: 24px;
    min-height: 100vh;
    box-sizing: border-box;
  .teams{
    .item{
      border-radius: 5px;
      background: #fff;
      margin-top: 12px;
      padding: 12px;
      // display: flex;
      // align-items: center;
      .info{
        display: flex;
        justify-content: space-between;
        img{
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .left{
          color: #666666;
          flex: 1;
          .team-name{
            font-size: 14px;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .group-name{
            font-size: 12px;
            color: #666666;
            margin-bottom: 8px;
            padding-left: 20px;
          }
          .tuihui{
            font-size: 10px;
            margin: 2px 0;
          }
          .match-name{
           font-size: 12px;
            font-weight: 500;
            color: #73767A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .info{
              display: flex;
              align-items: center;
            }
            img{
              width: 15px;
              height: 15px;
              border-radius: 50%;
              margin-right: 4px;
            }
            .row{
              font-size: 13px;
              color: #4FB5CA;
              display: flex;
              align-items: center;
              span{
                display: inline-block;
                width: 5px;
                height: 5px;
                background: #4FB5CA;
                margin-right: 4px;
                border-radius: 50%;
              }
            }
          }
        }
      }
      .bottom{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 9px;
        font-size: 12px;
        color: #FF4D4F;
        padding-left: 10px;
      }
      .name{
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333333;
        .status{
          width: 46px;
          height: 20px;
          line-height: 20px;
          margin-right: 4px;
        }
      }
    }
    .player{
      display: flex;
      align-items: center;
      img{
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 14px;
      }
      .info2{
        flex: 1;
        color: #666666;
        .name{
          font-size: 14px;
          margin-bottom: 6px;
        }
        .team-name{
          font-size: 12px;
          margin-bottom: 6px;
        }
        .match-name{
          font-size: 12px;
          font-weight: 500;
          color: #73767A;
        }
      }
      .status-info{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;
        .pay-info{
          margin-top: 12px;
          .row{
            color: #4FB5CA;
            display: flex;
            align-items: center;
            font-size: 13px;
            span{
              display: inline-block;
              width: 5px;
              height: 5px;
              background: #4FB5CA;
              margin-right: 4px;
              border-radius: 50%;
            }
          }
        }
      }
    }
    .status{
      width: 55.57px;
      height: 25px;
      border-radius: 3px;
      text-align: center;
      line-height: 25px;
      font-size: 12px;
      color: #fff;
      &._0{
        color: #73767A;
      }
      &._1{
        color: #529B2E;
      }
      &._2{
        background: #C45656;
      }
    }
  }
}
</style>
